import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Icon, type IconSource } from '../icon'
import { Pressable } from '../pressable'
import { Text } from '../text'
import { VStack } from '../vstack'

export type PanelPlaceholderProps = {
    label: string
    icon?: IconSource
    inline?: boolean
    onPress?(): void
    className?: string
    testID?: string
}

/**
 * Universal empty-state placeholder (replaces the legacy `aos-ui` `PanelPlaceholder`):
 * a muted 52px icon centred over a muted, centred label at 50% opacity. `inline`
 * tightens the top spacing for use inside a panel rather than a full-height column.
 */
export const PanelPlaceholder: React.FC<PanelPlaceholderProps> = ({
    label,
    icon,
    inline = false,
    onPress,
    className,
    testID,
}) => (
    <Pressable
        disabled={!onPress}
        onPress={onPress}
        accessibilityRole={onPress ? 'button' : undefined}
        className={twMerge('w-full items-center opacity-50', className)}
    >
        <VStack className={twMerge('items-center', inline ? 'pt-5' : 'pt-[120px]')}>
            {icon && <Icon as={icon} size={52} className='mb-5 text-content-muted' />}
            <Text size='body' tone='muted' className='text-center' testID={testID}>
                {label}
            </Text>
        </VStack>
    </Pressable>
)

PanelPlaceholder.displayName = 'PanelPlaceholder'
